if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };

        // 从 Liquid 注入的产品数据（需在 share-button.liquid 中输出）
        this.productTitle = this.getAttribute('data-product-title') || document.title;
        this.productDescription = this.getAttribute('data-product-description') || '';
        this.productImageUrl = this.getAttribute('data-product-image') || '';
        this.productUrl = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
        this.urlToShare = this.productUrl;

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');

          this.elements.shareButton.addEventListener('click', async () => {
            const shareData = {
              title: this.productTitle,
              text: this.productDescription,
              url: this.urlToShare,
            };

            // 尝试附加图片（浏览器支持 canShare + files 时）
            if (this.productImageUrl && navigator.canShare) {
              try {
                const response = await fetch(this.productImageUrl);
                const blob = await response.blob();
                const file = new File([blob], `${this.productTitle}.jpg`, { type: 'image/jpeg' });
                shareData.files = [file];
              } catch (err) {
                console.warn('Failed to load product image for share:', err);
              }
            }

            try {
              await navigator.share(shareData);
            } catch (err) {
              console.warn('navigator.share failed:', err);
              this.fallbackCopy();
            }
          });
        } else {
          // 不支持 navigator.share 的 fallback 逻辑（保持原样）
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess || 'Link copied!';
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        }).catch(err => {
          console.error('Copy failed:', err);
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}